import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
